import { RealEstate } from '../../../@types/real-estate-api-types'
import { DispatchType } from '../../../@types/redux-types'
import { InitState } from '../../reducers/root/initialState'
import { loadAISuggestionError, loadAISuggestionSuccess } from '../../reducers/suggestedText/suggestedTextFeature'
import { generateSuggestionFromGenAi } from '../../../api/generateSuggestion/generateAISuggestionApi'

export const loadSuggestedTextsFromGenAi =
  (realEstate: RealEstate) => async (dispatch: DispatchType, getState: () => InitState) => {
    const { isTitleManuallyEdited, isDescriptionManuallyEdited, isLocationManuallyEdited } =
      getState().suggestedTextFeature
    if (isLocationManuallyEdited || isTitleManuallyEdited || isDescriptionManuallyEdited) {
      return
    }
    try {
      const suggestions = await generateSuggestionFromGenAi(realEstate)
      dispatch(loadAISuggestionSuccess({ suggestions }))
    } catch (error) {
      dispatch(loadAISuggestionError())
    }
  }
